import { render, staticRenderFns } from "./functionpage.vue?vue&type=template&id=3ade1642&scoped=true"
import script from "./functionpage.vue?vue&type=script&lang=js"
export * from "./functionpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade1642",
  null
  
)

export default component.exports